"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Settings = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactRouterDom = require("react-router-dom");
var _Button = require("./Button");
var _utils = require("../../../../../utils");
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var MarginWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  margin-left: 31px;\n  ", "\n  ", "\n"])), _utils.mediaQuery.lessThan('md')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    margin-left: 25px;\n  "]))), _utils.mediaQuery.lessThan('sm')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    margin-left: 20px;\n  "]))));
var Settings = function Settings(_ref) {
  var color = _ref.color,
    path = _ref.path,
    children = _ref.children;
  var history = (0, _reactRouterDom.useHistory)();
  return /*#__PURE__*/_react.default.createElement(MarginWrapper, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex",
    onClick: function onClick() {
      return history.push(path);
    }
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    dotColor: color
  }), children));
};
exports.Settings = Settings;